import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeatherService } from './weather.service';
import { getWeatherIcon, getWeatherLabel } from './weather-icon.util';

@Component({
  selector: 'app-weather',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './weather.component.html',
  styleUrl: './weather.component.css',
})
export class WeatherComponent implements OnInit {
  private weatherService = inject(WeatherService);

  currentTemp = this.weatherService.currentTemp;
  feelsLike = this.weatherService.feelsLike;
  weatherCode = this.weatherService.currentWeatherCode;
  dailyForecast = this.weatherService.dailyForecast;
  rainSummary = this.weatherService.rainSummary;
  loading = this.weatherService.loading;
  error = this.weatherService.error;

  getIcon = getWeatherIcon;
  getLabel = getWeatherLabel;

  ngOnInit(): void {
    this.weatherService.start();
  }

  getDayLabel(date: Date): string {
  const today = new Date();
  const entryMidnight = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const dayOffset = Math.round((entryMidnight.getTime() - todayMidnight.getTime()) / 86_400_000);

  if (dayOffset === 0) return 'Danas';
  if (dayOffset === 1) return 'Sutra';
  return date.toLocaleDateString('hr-HR', { weekday: 'short' });
}
}